import * as commonApis from "./commonApis";
import { API_HOST_NAME } from "constants/SystemConstant";

export const getChartDsTheoNgay = (params, callback, callbackErr) => {
  let url = API_HOST_NAME + "/api/reports/dstheongay";
  let token = localStorage.getItem("token");
  commonApis.GET(url, token, params, callback, callbackErr);
};